import { render, staticRenderFns } from "./LoginNav.vue?vue&type=template&id=0b10e888&"
import script from "./LoginNav.vue?vue&type=script&lang=js&"
export * from "./LoginNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports